<template>
  <div class="fixed-tab" :style="{'height':styles.height}">
    <div :style="{'height':height}">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "FixedTab",
  props: {
    height: {
      type: Number,
      default: 88
    },
    top: {
      type: Number,
      default: 0
    }
  },
  computed: {
    styles() {
      // 计算高度
      let cw = document.body.clientWidth;
      let height = (cw * this.height) / 750 + "px";
      let top = (cw * this.height) / 750 + "px";
      return {
        height,
        top
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.fixed-tab {
  width: 100%;
  > div {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    height: auto;
    z-index: 999;
    background: #fff;
  }
}
.h88 {
  height: 88px;
}
</style>
